export const LOAD_STORE_LANDING_PAGE = 'LOAD_STORE_LANDING_PAGE';
export const EDIT_STORE_LANDING_PAGE = 'EDIT_STORE_LANDING_PAGE';
